export const diets = /* GraphQL */ `
  query {
    diet {
      id
      name
    }
  }
`
